/** Map any thrown value to a translation key under `errors.*`. */

const RPC_ERROR_CODES = [
  'AUTH_REQUIRED',
  'RATE_LIMITED',
  'SEASON_NOT_FOUND',
  'INVALID_TEAM_NAME',
  'INVALID_PICKS',
  'INVALID_SQUAD_SIZE',
  'DUPLICATE_PICKS',
  'INVALID_STARTING_COUNT',
  'INVALID_CAPTAINCY',
  'PLAYER_NOT_IN_COMPETITION',
  'INVALID_FORMATION',
  'BUDGET_EXCEEDED',
  'INVALID_LEAGUE_NAME',
  'NO_FANTASY_TEAM',
  'LEAGUE_NOT_FOUND',
  'DUEL_FULL',
  'LEAGUE_FULL',
  'NOT_A_MEMBER',
  'INSUFFICIENT_FUNDS',
  'DRAW_NOT_FOUND',
  'AD_CAP_REACHED',
  'AD_NOT_COMPLETED',
  'TEAM_NOT_FOUND',
  'INVALID_PICK',
  'INVALID_STAKE',
  'FIXTURE_NOT_FOUND',
  'PREDICTION_NOT_AVAILABLE',
  'ALREADY_PICKED',
  'PREDICTION_LOCKED',
  'OAUTH_DISABLED',
  'INVALID_CHIP',
  'GAMEWEEK_NOT_FOUND',
  'DEADLINE_PASSED',
  'CHIP_ALREADY_USED',
  'CHIP_ALREADY_ACTIVE',
  'SPIN_COOLDOWN',
  'GAMEWEEK_LIVE',
  'INVALID_SPIN_COUNT',
  'DUPLICATE_SPIN_PICKS',
  'SPIN_PICKS_NOT_ONE_NATION',
  'REFERRAL_INVALID',
  'REFERRAL_NOT_FOUND',
  'REFERRAL_SELF',
  'REFERRAL_ALREADY_REDEEMED',
  'NOT_LIVE',
  'ONE_PER_GROUP',
  'ALREADY_DOUBLED',
  'NO_REWARD_TO_DOUBLE',
  'PREDICTION_NOT_SETTLED',
  'PREDICTION_NOT_FOUND',
  'FREEZE_MAX',
  'INVALID_PACK_KIND',
  'NO_STICKERS',
  'PACK_ALREADY_OPENED',
  'ACCA_FULL',
  'FIXTURE_LOCKED',
  'FIXTURE_NOT_IN_COMPETITION',
  'INVALID_SELECTION',
  'NO_OPEN_ROUND',
  'SURVIVOR_OUT',
  'TEAM_ALREADY_USED',
  'TEAM_NOT_PLAYING',
  'CHALLENGE_NOT_FOUND',
  'CHALLENGE_LOCKED',
  'INVALID_OPTION',
  'ITEM_NOT_FOUND',
  'ITEM_INACTIVE',
  'ALREADY_OWNED',
  'NOT_OWNED',
  'GAMEWEEK_LOCKED',
  'NEED_ELEVEN',
  'DUPLICATE_PLAYER',
  'CAPTAIN_NOT_IN_XI',
  'PLAYER_NOT_FOUND',
] as const;

type RpcErrorCode = (typeof RPC_ERROR_CODES)[number];

function isRpcErrorCode(value: string): value is RpcErrorCode {
  return (RPC_ERROR_CODES as readonly string[]).includes(value);
}

function extractMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string') return message;
  }
  if (typeof error === 'string') return error;
  return '';
}

/** Translation key (e.g. "errors.BUDGET_EXCEEDED") for any caught error. */
export function errorKey(error: unknown): string {
  const message = extractMessage(error);
  // RPCs raise bare codes; PostgREST may wrap them in a longer sentence.
  const match = message.match(/[A-Z][A-Z_]{2,}/);
  if (match && isRpcErrorCode(match[0])) {
    return `errors.${match[0]}`;
  }
  if (/network|fetch failed|timeout|abort/i.test(message)) {
    return 'errors.network';
  }
  return 'errors.unknown';
}
